module.exports = __webpack_public_path__ + "img/cd-icon-filter.92cf9732.svg";